import { ModalEmitters, ModalEvents } from '@/lib/Modal/ModalEvents';
import { nextTick, ref } from 'vue';

type Hooks = {
	onConfirm?: () => void | Promise<void>;
	onClose?: () => void | Promise<void>;
	onShow?: () => void | Promise<void>;
};

export function useModal(name: string, emit: ModalEmitters, hooks: Hooks = {}) {
	const visible = ref<boolean>(false);
	const isSaving = ref<boolean>(false);

	const show = async () => {
		visible.value = true;
		await hooks.onShow?.();
	};

	const onClosed = () => {
		if (isSaving.value) {
			return;
		}

		visible.value = false;
		nextTick(function () {
			emit(ModalEvents.Reveal, null);
		});

		hooks.onClose?.();
	};

	const onConfirmed = async () => {
		isSaving.value = true;
		try {
			await hooks.onConfirm?.();
			visible.value = false;
		} catch {
			console.error('Error during confirmation action');
		} finally {
			isSaving.value = false;
		}
	};

	const toggle = () => {
		visible.value = !visible.value;
		if (visible.value) {
			nextTick(function () {
				emit(ModalEvents.Reveal, name);
			});
		}
	};

	return { visible, toggle, show, onClosed, onConfirmed, isSaving };
}
